<ion-buttons class="justify-content-end" slot="end">
        @if (isManagerOrServiceDesk()) {
          <div class="d-flex flex-column align-items-center align-self-center">
            <ion-badge class="first-badge" (click)="goToUnreadList()">
              {{ unreadCountLabel() }}
            </ion-badge>
            @if (showLabels()) {
              <small class="text-muted">{{'unread' | transloco}}</small>
            }
          </div>
        }
        @if (isManagerOrReporter()) {
          <div class="d-flex flex-column align-items-center align-self-center">
            <ion-badge class="second-badge" (click)="goToUnreadMessagesList()">
              {{ unreadMessagesCountLabel() }}
            </ion-badge>
            @if (showLabels()) {
              <small class="text-muted">{{'messages' | transloco}}</small>
            }
          </div>
        }
        @if (isManagerOrReporter()) {
          <div class="d-flex flex-column align-items-center align-self-center">
            <ion-badge class="third-badge" (click)="goToUnreadClosedMessagesList()">
              {{ unreadClosedMessagesCountLabel() }}
            </ion-badge>
            @if (showLabels()) {
              <small class="text-muted">{{'closed' | transloco}}</small>
            }
          </div>
        }
      </ion-buttons>